export default function TrimIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.6154 2.5H2.38462C2.01739 2.5 1.66521 2.64367 1.40554 2.8994C1.14588 3.15513 1 3.50198 1 3.86364V16.1364C1 16.498 1.14588 16.8449 1.40554 17.1006C1.66521 17.3563 2.01739 17.5 2.38462 17.5H17.6154C17.9826 17.5 18.3348 17.3563 18.5945 17.1006C18.8541 16.8449 19 16.498 19 16.1364V3.86364C19 3.50198 18.8541 3.15513 18.5945 2.8994C18.3348 2.64367 17.9826 2.5 17.6154 2.5ZM2.38462 6.59091H9.30769V13.4091H2.38462V6.59091ZM10.6923 5.22727V3.86364H13.4615V5.22727H10.6923ZM9.30769 5.22727H6.53846V3.86364H9.30769V5.22727ZM9.30769 14.7727V16.1364H6.53846V14.7727H9.30769ZM10.6923 14.7727H13.4615V16.1364H10.6923V14.7727ZM10.6923 13.4091V6.59091H17.6154V13.4091H10.6923ZM17.6154 5.22727H14.8462V3.86364H17.6154V5.22727ZM5.15385 3.86364V5.22727H2.38462V3.86364H5.15385ZM2.38462 14.7727H5.15385V16.1364H2.38462V14.7727ZM17.6154 16.1364H14.8462V14.7727H17.6154V16.1364Z" />
    </svg>
  );
}
